import { render } from "./SearchComponent.vue?vue&type=template&id=4f5ca66a&scoped=true"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"

import "./SearchComponent.vue?vue&type=style&index=0&id=4f5ca66a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hanlin-lesson-plan/hanlin-lesson-plan/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5ca66a"]])

export default __exports__